import { useState, useContext, useEffect } from 'react'
import Modal from 'react-modal'
import axios from 'axios'

import { projectContext, loadingContext, unfolder, useTranslate } from '../lib'
import { urlValue } from '../lib'

import '../styles/selectCodeModal.scss'
import { customModal } from '../styles/customModal'

export default function SelectContextModal({ isModalOpen, setIsModalOpen, setValue, typeInput, outputContext}) {
  const [loading, setLoading] = useContext(loadingContext)
  const [search, setSearch] = useState('')
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [intents, setIntents] = useState([])
  const { t } = useTranslate();
  useEffect(() => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/${selectedProject.id}/intents`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        setIntents(response.data)
        setLoading(false)
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }, [])

  function onSubmit(value) {
    if(typeInput == true){
        setValue('inputContextNames', value)
        setValue('outputContexts', outputContext)
    }
    else {
        setValue('outputContexts', value)

    }
    setSearch('')
    setIsModalOpen({ delete: false, code: false })
  }

  return (
    <Modal isOpen={isModalOpen.code} style={customModal} ariaHideApp={false}>
      <div className="selectCode-modal">
        <h1>{t('menu.selectContext')}</h1>
        <span
          onClick={() => {
            setIsModalOpen({ delete: false, code: false })
          }}
        >
          X
        </span>
        <input
          onChange={event => {
            setSearch(event.target.value)
          }}
        ></input>
        <div className="intents">
          {intents
            .filter(value => {
              if (search == '' && (value.output_context || '') !== '' ) {
                return value
              } else if ((value.output_context || '') !== '' && (value.output_context || '').toLowerCase().includes(search.toLowerCase())) {
                return value
              }
            })
            .map((data, index) => (
              <button key={index} onClick={() => onSubmit((data.output_context || '').toLowerCase()) }>
                <p>{(data.output_context || '').toLowerCase()}</p>
              </button>
            ))}
        </div>
      </div>
    </Modal>
  )
}
